import { isString } from 'util'; // eslint-disable-next-line @typescript-eslint/no-explicit-any

export var replaceHexToString = function replaceHexToString(text) {
  if (!isString(text)) {
    return text;
  }

  return text.split('\n').map(function (line) {
    return line.replace(/<U\+([0-9a-fA-F]+)>+/g, function (match, hex) {
      var decimal = parseInt(hex, 16);
      var char = String.fromCodePoint(decimal); // eslint-disable-next-line no-restricted-globals

      if (isNaN(decimal) || char === "\0") {
        return match;
      }

      return char;
    });
  }).join('\n');
};